import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';

export default css({
  '&.file-select-button': {
    visibility: 'hidden',
    border: '2px solid white',
    borderRadius: '3px',
    display: 'flex',
    opacity: '0.8',
    width: '29.5px',
    height: '29.5px',
    alignItems: 'center',
    justifyItems: 'center',
    '&--show': {
      visibility: 'visible',
    },
    '&--selected': {
      background: COLORS.PRIMARY500,
      border: '5px solid white',
    },
    '&:not(:disabled):hover, &:not(:disabled):hover svg': {
      color: COLORS.WHITE,
    },
    '&--selected:not(:disabled):hover, &--selected:not(:disabled):hover svg': {
      background: COLORS.PRIMARY500,
    },
  },
  '.file-select-button': {
    '&__btn': {
      fontSize: '0.75rem',
      padding: '0',
      display: 'flex',
      alignItems: 'center',
      justifyItems: 'center',
      width: '25px',
      height: '25px',
    },
    '&__btn svg': {
      margin: '0 auto',
    },
  },
});
